module.exports = __webpack_public_path__ + "media/online_learning/resource-01-80ca61ee.png";